var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConocoPhilips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 24,
    viewBox: "0 0 100 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8907 13.5617L86.759 12.307H84.9145V23.5328L87.0225 23.5988V19.4387C87.8129 20.033 87.8788 20.2971 88.9328 20.4952C89.7892 20.6273 90.7114 20.4292 91.436 20.033C94.1369 18.6463 94.3345 13.6937 91.1725 12.373C90.3161 12.0429 89.4598 12.0429 88.6034 12.307C87.6153 12.5712 87.2201 13.2975 86.8907 13.5617ZM87.0225 16.7313C86.8248 15.4766 87.4836 14.0899 88.8011 13.8258C90.1185 13.5617 91.3043 14.5522 91.3702 15.8728C91.5019 19.3726 88.6693 19.1085 87.813 18.3161C87.1542 17.7878 87.1542 17.5237 87.0225 16.7313Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5296 19.1745C61.5296 19.3726 61.4637 20.1651 61.5955 20.2971H63.7034C63.8352 19.9669 63.7693 17.5897 63.7693 17.1275C63.7693 16.203 63.5717 15.0805 64.2304 14.4201C64.8233 13.8918 65.8773 13.6937 66.536 14.222C67.2606 14.8824 67.2606 15.8729 67.2606 16.7973V20.3632H69.3686C69.4345 18.9764 69.4344 17.4577 69.4344 16.071C69.4344 11.8448 65.7455 11.2505 63.8352 13.4956V8.67518H61.6613V19.1745H61.5296Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1637 9.00535V20.2971H55.2716L55.3375 15.8729C57.182 15.8068 57.9066 16.137 59.6852 15.0805C61.5297 13.9579 62.1884 9.79775 58.1043 8.93931C57.3796 8.80725 55.2058 8.80725 54.4153 8.87328C54.0859 8.93931 53.4931 9.00535 53.1637 9.00535ZM55.2716 14.156V10.4581C56.5891 10.4581 59.0923 10.0619 59.0265 12.307C58.9606 13.0994 58.5654 13.6938 57.8407 13.9579C56.9185 14.4201 56.1939 14.156 55.2716 14.156Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42307 19.9009L9.02784 18.3161C8.23736 18.3821 6.327 19.2406 4.2849 18.3161C1.51819 17.0615 1.38645 12.7032 4.2849 11.3165C4.94365 10.9864 5.93176 10.8543 6.5905 10.8543C7.57861 10.8543 8.17146 11.2505 8.96195 11.3165L9.48893 9.66568C5.27299 8.08087 0.13484 9.79775 0.0030919 14.8163C-0.0627821 16.9954 0.92532 18.7783 2.83567 19.7689C4.54839 20.6273 7.64447 20.7594 9.42307 19.9009Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6303 12.175C45.1271 12.5051 43.4144 14.0239 43.612 16.7313C43.8096 19.3066 46.0493 20.6273 48.4208 20.4952C54.2177 20.033 53.4931 11.3825 47.6303 12.175ZM50.1994 16.5992C49.9359 17.9859 49.343 19.1085 47.6962 18.9104C46.3128 18.7123 45.72 17.1935 45.8517 15.9389C46.3128 12.307 50.7264 13.3636 50.1994 16.5992Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3755 12.175C7.381 12.9674 8.3691 20.8914 14.2319 20.4952C19.8971 20.033 19.3042 11.3825 13.3755 12.175ZM15.8787 16.9294C15.1541 20.3631 10.9382 19.1745 11.5969 15.6747C12.1898 12.373 16.6692 13.3636 15.8787 16.9294Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2271 12.175C25.2326 12.9674 26.2207 21.0235 32.1494 20.4952C37.8145 19.967 37.0899 11.4486 31.2271 12.175ZM33.7304 16.9294C33.1375 20.2311 28.7898 19.3066 29.4486 15.6748C30.0414 12.5051 34.3891 13.1655 33.7304 16.9294Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7535 13.5617L20.6218 12.241H18.7773L18.8432 20.2311H20.9512C20.9512 18.8444 20.9512 17.5237 20.9512 16.137C20.9512 15.4106 20.8853 15.0805 21.3464 14.4862C21.6758 14.09 22.2027 13.8258 22.6639 13.7598C24.0472 13.6277 24.4425 14.9484 24.4425 16.071C24.4425 17.4577 24.4425 18.8444 24.4425 20.2311H26.5504C26.5504 18.3822 26.9457 14.5522 25.8259 13.1655C25.233 12.3731 24.1131 11.9108 23.125 12.0429C21.8734 12.307 21.6099 12.6372 20.7535 13.5617Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9176 2.00576C46.3128 2.46799 46.7739 2.79816 47.235 3.32643C49.1454 5.76968 49.4747 8.67517 49.6723 8.87327C50.7263 8.93931 55.2717 6.03382 56.3256 5.30745C56.7868 4.97728 57.3796 4.51504 57.8407 4.25091C58.4336 3.92074 58.9606 3.72264 59.5534 3.32643C60.2122 2.93023 62.0567 1.60956 62.3861 0.949219C60.8051 1.74162 60.6733 1.41146 58.763 2.93023C57.182 4.18487 57.4455 4.44901 54.6788 4.44901C50.1335 4.44901 48.4866 2.6661 45.9176 2.00576Z",
    fill: "#BA3F43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3349 18.3161L93.8737 19.8349C95.1912 20.4952 96.8381 20.6933 98.2214 20.1651C99.6048 19.7028 100.461 18.2501 99.7365 16.8634C99.0119 15.4106 97.365 15.6748 96.4428 14.9484C95.4547 14.156 96.9039 12.8353 99.2095 14.09L99.6048 12.6372C98.3532 12.0429 96.7063 11.9108 95.4547 12.5712C94.2031 13.2315 93.6102 14.8163 94.5983 16.0049C95.4547 16.9954 97.6944 17.1275 97.8262 17.9199C98.2214 19.6368 95.1254 18.7783 94.3349 18.3161Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6118 19.9669L43.2824 18.4482C42.2284 18.7123 41.372 18.9764 40.2522 18.5802C39.3299 18.184 38.8688 17.3256 38.8029 16.4011C38.6712 14.0899 41.3721 13.2315 43.1507 14.156L43.5459 12.5712C41.8332 12.1089 40.3839 11.8448 38.7371 12.7693C35.8386 14.288 35.8386 18.6463 38.6712 20.033C40.1205 20.6273 42.3602 20.6933 43.6118 19.9669Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7346 20.2311L78.7227 20.2971H79.8426L79.9084 19.3066V8.60912H77.7346V20.2311Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0453 20.2311L75.0334 20.2971H76.1532L76.2191 19.3066V8.60912H74.0453V20.2311Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5541 12.307V20.2971H72.662V12.307H70.5541Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2916 12.307L81.2258 20.2971H83.3996V12.307H81.2916Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.345 8.87328C71.0156 8.93931 70.818 8.93931 70.5545 9.26948C69.8958 10.194 70.7521 11.3826 71.8061 11.1184C73.5188 10.7222 72.926 8.47707 71.345 8.87328Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0823 8.87328C80.2378 9.33551 81.2259 11.4486 82.5434 11.1184C84.1903 10.7222 83.6633 8.47707 82.0823 8.87328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConocoPhilips);
export default __webpack_public_path__ + "static/media/conocoPhilips.68738d63236e8300f4e1e2d35833fa33.svg";
export { ForwardRef as ReactComponent };